import * as THREE from "three";
import { useRef } from "react";
import { useFrame, useLoader } from "@react-three/fiber";
import { getOrbitDetails, setHoverPlanet } from "../../../feature/orbit-slice";
import { useDispatch, useSelector } from "react-redux";
import { Text } from "@react-three/drei";
// Types
interface Planet {
  children: any;
  id: string | number;
  position: [number, number, number];
  category_image: string;
  pro_id: any;
}

interface Orbit {
  id: string | number;
  position: [number, number, number];
  planet: Planet[];
  category_image: string;
  stage: number;
}

interface OrbPlanetsProps {
  planetData: Orbit[];
  onPlanetHover: any;
  onPlanetClick: any;
}

const Planets = ({
  planet,
  orbitSlice,
  speed,
  onPlanetHover,
  onPlanetClick,
}: {
  planet: Planet;
  orbitSlice: any;
  speed: any;
  onPlanetHover: any;
  onPlanetClick: any;
}) => {
  const dispatch = useDispatch();
  const planetRef = useRef<any>(null);
  const texture = useLoader(THREE.TextureLoader, planet?.category_image);

  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.repeat.set(1, 1);
  const onHover = (value: any, type: "in" | "out") => {
    if (orbitSlice.selectOrbit) {
      onPlanetHover(value, type);

      dispatch(setHoverPlanet(type === "in" ? value.pro_id : null));
    }
  };

  useFrame(() => {
    if (planetRef.current && orbitSlice.hoverPlanet !== planet.pro_id) {
      planetRef.current.rotation.z += -0.02;
    }
  });
  if (!planet.position) return null;
  if (planet.children && planet.children.length > 0) {
    return (
      <mesh position={planet.position} onClick={() => onPlanetClick(planet)}
           onPointerOver={(e) => onHover(planet, "in")}
        onPointerOut={(e) => onHover(planet, "out")}
      
      >
        <circleGeometry args={[0.2, 32]} />
        <meshBasicMaterial color="lightblue" transparent opacity={0.6} />
        <Text
          position={[0, 0, 0.01]}
          fontSize={0.1}
          color="white"
          anchorX="center"
          anchorY="middle"
        >
          {`+${planet.children.length}`}
        </Text>
      </mesh>
    );
  } else {
    return (
      <mesh
        ref={planetRef}
        position={planet.position}
        onClick={() => onPlanetClick(planet)}
        onPointerOver={(e) => onHover(planet, "in")}
        onPointerOut={(e) => onHover(planet, "out")}
      >
        <boxGeometry args={[0.45, 0.45, 0]} />
        <meshBasicMaterial map={texture} transparent />
      </mesh>
    );
  }

  // return (

  //   <mesh ref={planetRef} position={planet.position}     onClick={() => onPlanetClick(planet)}  onPointerOver={(e) => onHover(planet, "in")}
  //   onPointerOut={(e) => onHover(planet, "out")}>
  //     <boxGeometry args={[0.45, 0.45, 0]} />
  //     <meshBasicMaterial map={texture} transparent />
  //   </mesh>
  // );
};

const PlanetStage = ({
  orbit,
  orbitSlice,
  onPlanetHover,
  onPlanetClick,
}: {
  orbit: Orbit;
  orbitSlice: any;

  onPlanetHover: any;
  onPlanetClick: any;
}) => {
  const circleRef = useRef<any>(null);

  const speed =
    orbit?.stage === 3
      ? 0.008
      : orbit?.stage === 2
        ? 0.005
        : orbit?.stage === 1
          ? 0.005
          : 0;
  // const speed =orbit.stage === 3 ? 0.03 : orbit.stage === 2 ? 0.02 : orbit.stage === 1 ? 0.02 : 0;

  useFrame((state) => {
    if (circleRef.current && !orbitSlice.hoverPlanet) {
      circleRef.current.rotation.z -= speed;
    }
  });

  return (
    <mesh position={[0, 0, 0]} ref={circleRef}>
      {orbit?.planet.map((planet: Planet) => (
        <Planets
          key={planet.id}
          planet={planet}
          orbitSlice={orbitSlice}
          speed={speed}
          onPlanetHover={onPlanetHover}
          onPlanetClick={onPlanetClick}
        />
      ))}
    </mesh>
  );
};

const OrbPlanets = ({
  planetData,
  onPlanetHover,
  onPlanetClick,
}: OrbPlanetsProps) => {
  const orbitSlice = useSelector(getOrbitDetails);

  return (
    <>
      {planetData.map((orbit: Orbit) => (
        <PlanetStage
          key={orbit?.id}
          orbit={orbit}
          orbitSlice={orbitSlice}
          onPlanetHover={onPlanetHover}
          onPlanetClick={onPlanetClick}
        />
      ))}
    </>
  );
};

export default OrbPlanets;
